module.exports = __webpack_public_path__ + "img/bar2.988cf01e.jpg";